// extracted by extract-css-chunks-webpack-plugin
module.exports = {"scroll-to-top-button":"styles__scroll-to-top-button___389KX","scrollToTopButton":"styles__scroll-to-top-button___389KX","scroll-to-top-icon":"styles__scroll-to-top-icon___3IX02","scrollToTopIcon":"styles__scroll-to-top-icon___3IX02"};
    if(module.hot) {
      // 1765762318851
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  